// No PIN / UNPIN / REORDER action: the API replaces the whole ordered list, so
// modelling them separately would misrepresent it.
const actions = {
  SET_STATE: 'pinnedConversations/SET_STATE',
  /** GET the admin-global list. */
  LIST: 'pinnedConversations/LIST',
  /** PUT the whole ordered list — adds, removes and reorders in one call. */
  REPLACE: 'pinnedConversations/REPLACE',
} as const

export default actions
